import axios from "axios";

class Settings {
    constructor() {
        this.hostname = "";
        let port = "";
        if (window.location.port) {
            port = `:${window.location.port}`;
        }
        this.hostname = `${window.location.protocol}//${window.location.hostname}${port}`;
    }
    load = async () => {
        var response = await axios(this.hostname + "/spa/config");
        Object.assign(this, response.data);
        const oauthConfig = {
            client_id:"oauth",
            scope: "openid profile user_notification_api canManageUsers oauth_user_reader",
            oauthAuthority: this.oauthAuthority,
            hostAuthority: this.hostname,
            userNotificationHost: this.UserNotificationHost
        };
        this.oauthConfig = oauthConfig;

        return this;
    }
}

const settings = new Settings();
export const settingsPromise = settings.load();
export default settings;